import { useContext } from 'react'
import FilterContext from './filter-context'

/**
 * useFilter
 */
const useFilter = () => {
  const context = useContext(FilterContext)
  return context
};

export default useFilter
